/**
 * Runtime polyfills for APIs used by dependencies but missing in older browsers.
 * Babel down-levels *syntax* per browserslist, but does not add missing runtime
 * methods — those need explicit shims.
 */

// Promise.withResolvers — ES2024 (Chrome 119+, Firefox 121+, Safari 17.4+).
// Used at runtime by pdfjs-dist 4+ (react-pdf 9+); older browsers/webviews
// would otherwise throw when opening a PDF (e.g. agreement steps, OCR viewer).
//
// IMPORTANT: this package declares a "sideEffects" allowlist in package.json.
// This file MUST stay listed there (dist/utils/polyfills.js), otherwise bundlers
// legitimately tree-shake the whole module away — regardless of its content —
// and the polyfill silently never ships. Verified empirically with both esbuild
// and the apps' webpack production builds.
(function polyfillPromiseWithResolvers() {
  if (typeof Promise.withResolvers === 'function') return;

  Promise.withResolvers = function withResolvers() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve, reject };
  };
})();
